export default __webpack_public_path__ + "static/media/Mark-6-HUD-Targeting (Reticle).4dea962a.jpg";